module.exports = __webpack_public_path__ + "img/pdca-check.00ab2751.svg";